import { render, staticRenderFns } from "./Typography.vue?vue&type=template&id=e81affc8&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e81affc8')) {
      api.createRecord('e81affc8', component.options)
    } else {
      api.reload('e81affc8', component.options)
    }
    module.hot.accept("./Typography.vue?vue&type=template&id=e81affc8&", function () {
      api.rerender('e81affc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/basic-ui/Typography.vue"
export default component.exports